import React, { Component } from "react";
import { connect } from "react-redux";
import { Form } from "@ant-design/compatible";
import { Button, Input, Col, Row, Drawer, Divider } from "antd";
import { isMobile } from 'react-device-detect';
import CKEditorComponent from '@/components/Editor/CKEditorComponent'
import { createPost, updatePost, uploadPostImage } from "@/redux/actions/postActions";

class PostForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false
        };
    }

    submit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                const request = this.props.currentData
                    ? this.props.updatePost(this.props.currentData.id, values)
                    : this.props.createPost(values);

                request
                    .then(() => {
                        this.props.reloadData();
                        this.onClose();
                    })
                    .catch(() => this.setState({ isLoading: false }));
            }
        });
    }

    onClose() {
        this.setState({
            isLoading: false
        });
        this.props.form.resetFields();
        this.props.onCancel();
    }

    render() {
        const { visible, currentData } = this.props;
        const { isLoading } = this.state;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title={currentData ? `Cập nhật bài viết` : 'Thêm bài viết mới'}
                width={isMobile ? '100%' : '60%'}
                onClose={() => this.onClose()}
                maskClosable={false}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => this.onClose()}>
                            Huỷ
                        </Button>
                        <Divider type='vertical' />
                        <Button
                            loading={isLoading}
                            key="submit"
                            type="primary"
                            onClick={(e) => this.submit(e)}
                        >
                            Lưu
                        </Button>
                    </div>
                }
            >
                {visible ? (
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Tiêu đề">
                                    {getFieldDecorator("title", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentData ? currentData?.title : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Tiêu đề hiển thị">
                                    {getFieldDecorator("header", {
                                        rules: [{ required: true, message: "Vui lòng nhập tiêu đề hiển thị!" }],
                                        initialValue: currentData?.header || null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Từ khóa">
                                    {getFieldDecorator("keyword", {
                                        rules: [{ required: true, message: "Vui lòng nhập từ khóa!" }],
                                        initialValue: currentData?.keyword || null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Tên miền sử dụng">
                                    {getFieldDecorator("domain_used", {
                                        rules: [{ max: 255, message: "Tên miền không được vượt quá 255 ký tự!" }],
                                        initialValue: currentData?.domain_used || null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Nội dung">
                                    {getFieldDecorator('edited_content', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentData?.edited_content || null
                                    })(
                                        <CKEditorComponent
                                            initialHeight="300px"
                                            editorData={currentData?.edited_content || ''}
                                            uploadFile={this.props.uploadPostImage}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                max: 255,
                                                message: "Ghi chú không được vượt quá 255 ký tự!",
                                            },
                                        ],
                                        initialValue: currentData?.note ?? null
                                    })(
                                        <Input.TextArea maxLength={255} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                ) : null
                }
            </Drawer>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updatePost: (id, data) => dispatch(updatePost(id, data)),
        createPost: data => dispatch(createPost(data)),
        uploadPostImage: file => dispatch(uploadPostImage(file))
    };
};

export default connect(null, mapDispatchToProps)(Form.create({ name: "PostForm" })(PostForm));
